// extracted by mini-css-extract-plugin
export default {"wrapper":"intentionsOver_wrapper__8ku7s","image":"intentionsOver_image__C51Uz","inside":"intentionsOver_inside__nl7F1"};